// extracted by mini-css-extract-plugin
export default {"root":"MaterialPosition__root___Wmo3w","arrow":"MaterialPosition__arrow___TzaAd","arrowUp":"MaterialPosition__arrowUp___ly9nV","arrowDown":"MaterialPosition__arrowDown___eZEJE"};